export default "__VITE_ASSET__VN7VY6Ox__"